import { render, staticRenderFns } from "./CustomTagsRichText.vue?vue&type=template&id=224f8b2a&"
import script from "./CustomTagsRichText.vue?vue&type=script&lang=js&"
export * from "./CustomTagsRichText.vue?vue&type=script&lang=js&"
import style0 from "./CustomTagsRichText.vue?vue&type=style&index=0&id=224f8b2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports